import { motion } from "framer-motion";
import { PencilRuler, CalendarClock } from "lucide-react";
import Reveal from "@/components/Reveal";

const POINTS = [
  { icon: CalendarClock, title: "Made for little attention spans", text: "Two minutes is the perfect adventure length for toddlers and their grown-ups." },
  { icon: PencilRuler, title: "A new story every week", text: "The park is big, and Bubz's questions are endless. There's always somewhere new to explore." },
];

export default function Creator() {
  return (
    <section id="creator" data-testid="creator-section" className="relative py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-[3rem] border-2 border-bubz-grape/30 bg-white p-8 shadow-[0_24px_70px_rgba(181,126,220,0.18)] sm:p-14">
          <div className="grid items-center gap-10 lg:grid-cols-2">
            <Reveal>
              <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.3em] text-bubz-grape">
                The maker behind the magic
              </p>
              <h2 className="font-display text-3xl font-bold leading-tight text-bubz-ink sm:text-5xl">
                Created by{" "}
                <span className="relative inline-block">
                  J.J. STONE
                  <svg
                    className="absolute -bottom-2 left-0 w-full"
                    viewBox="0 0 200 12"
                    fill="none"
                    aria-hidden="true"
                  >
                    <motion.path
                      d="M3 9C50 3 120 3 197 8"
                      stroke="#FFD034"
                      strokeWidth="6"
                      strokeLinecap="round"
                      initial={{ pathLength: 0 }}
                      whileInView={{ pathLength: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.9, delay: 0.3, ease: "easeOut" }}
                    />
                  </svg>
                </span>
              </h2>
              <p className="mt-6 max-w-lg text-base font-semibold leading-relaxed text-bubz-ink/65 sm:text-lg">
                BUBZ &amp; BUBBLES began seeing bubbles blown excite the magical wonder in children.
                Now it's a weekly 2D animated series about curiosity, friendship, and the magic
                hiding in an ordinary sunny afternoon at the park.
              </p>
            </Reveal>

            <div className="space-y-4">
              {POINTS.map((p, i) => (
                <Reveal key={p.title} delay={0.12 + i * 0.1}>
                  <motion.div
                    data-testid={`creator-point-${i}`}
                    className="flex items-start gap-4 rounded-3xl bg-bubz-cream p-5"
                    whileHover={{ x: 8 }}
                    transition={{ type: "spring", stiffness: 260, damping: 18 }}
                  >
                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-bubz-grape/15">
                      <p.icon size={22} className="text-bubz-grape" />
                    </span>
                    <span>
                      <span className="block font-display text-lg font-semibold text-bubz-ink">{p.title}</span>
                      <span className="mt-1 block text-sm font-semibold leading-relaxed text-bubz-ink/60">{p.text}</span>
                    </span>
                  </motion.div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
